import { render, staticRenderFns } from "./riskQdsj.vue?vue&type=template&id=4efee70d&scoped=true&"
import script from "./riskQdsj.vue?vue&type=script&lang=js&"
export * from "./riskQdsj.vue?vue&type=script&lang=js&"
import style0 from "./riskQdsj.vue?vue&type=style&index=0&id=4efee70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efee70d",
  null
  
)

export default component.exports